function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.75 11A2.75 2.75 0 0011 8.24V6.17h1.17a5.41 5.41 0 011.56.24 2.87 2.87 0 011.14.7 2.75 2.75 0 01.7 1.15 5.09 5.09 0 01.24 1.56V11h2.06L22 15.11V7.39a7.45 7.45 0 00-2.17-5.23A7.39 7.39 0 0017.47.57 7.25 7.25 0 0015 0H8.25v11H11v2.74L19.25 22H22v-2.76zm4.64-7.4a5.35 5.35 0 011.55 3.8V11h-2.07V9.38a5.25 5.25 0 00-.41-2.05 5.3 5.3 0 00-1.13-1.67 5 5 0 00-1.67-1.13 5.15 5.15 0 00-2.05-.42H11V2.06h3.59a5.34 5.34 0 013.8 1.53zM9.28 19.93a1 1 0 101 1 1 1 0 00-1-1zm-8.28 0a1 1 0 101 1 1 1 0 00-1-1zm4.16 0a1 1 0 101 1 1 1 0 00-1-1zm4.12-4.13a1 1 0 101 1 1 1 0 00-1-1zM1 15.8a1 1 0 000 2.07 1 1 0 000-2.07zm4.16 0a1 1 0 100 2.07 1 1 0 000-2.07z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.28 11.68a1 1 0 101 1 1 1 0 00-1-1zm-8.28 0a1 1 0 101 1 1 1 0 00-1-1zm4.16 0a1 1 0 101 1 1 1 0 00-1-1zM0 11h6.19V0H0zm11 11h4.12L11 17.87z",
  fill: "currentColor"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.e1c94538.svg";
export { ForwardRef as ReactComponent };